import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { compose } from "recompose";
import { withAuthorization, createUser } from "./utils/auth";
import {withRouter} from 'react-router-dom';
import {Link} from 'react-router-dom';
import * as routes from './routes';
import UserForm from "./UserForm";
import moment from 'moment-timezone';

import { Table, Modal, Spin, Input, Button, Alert, Tag, Icon, Divider } from "antd";
const Search = Input.Search;

@observer
class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      selection: [],
      loading: false,
      visible: false
    };

    this.doDelete = this.doDelete.bind(this);
    // this.getDocs = this.getDocs.bind(this);
    this.reset = this.reset.bind(this);

    console.log(this.props.location);
    if(this.props.location.data && this.props.location.data.fireStoreQuery) {
      //
    } else {
      console.log("hmm. Location data weirdness…");
    }
  }

  // getDocs = this.props.userStore.users.docs.map((doc, i) => ({
  //         key: i,
  //         firstname: doc.data.firstname,
  //         lastname: doc.data.lastname,
  //         city: doc.data.city,
  //         role: doc.data.role,
  //         uid: doc.id,
  //         doc: doc
  //       }));

  selector = {
    onChange: (selectedRowKeys, selectedRows) => {
      this.setState({selection: selectedRows});
    },
    getCheckboxProps: record => ({ // Disable checkbox on ADMIN USER
      disabled: record.role === 'admin'
    }),
  }
  renderTag = (value) => {
    if(value == 'admin') {
      return (<Tag color="volcano">admin</Tag>)
    }
    if(value == 'nurse'){
      return (<Tag color="blue">intervenant</Tag>)
    }
    if(value == 'patient'){
      return (<Tag color="purple">client</Tag>)
    }
  }
  renderLink = (text, user) => {
    return <Link to={{pathname: `/users/${user.uid}` }}>{text}</Link>
  }
  // search(query) {
  //   console.log('[QUERY]:', query);
  //   // this.props.userStore.users.query = this.props.userStore.users.query.ref.where('firstname', )
  // }
  doDelete(){
    this.setState({loading: true});
    this.state.selection.map(async (data) => {
      await data.doc.delete();
    })
    this.setState({selection: []});
    this.setState({loading: false});
  }
  reset() { // reset query to remove all filters
    this.props.userStore.users.query = undefined;
  }
  doStringSort(a, b){
    if(a === undefined && b === undefined || b === null && a === null){
      return 0;
    }
    if(a === undefined || a === null){
      console.log('A is Null', a);
      return -1;
    }
    if(b === undefined || b === null){
      console.log('B is Null', b);
      return -1;
    }

    return a.localeCompare(b);
  }
  doDateSort(a, b){
    if(a === undefined && b === undefined || b === null && a === null){
      return 0;
    }
    if(a === undefined || a === null){
      console.log('A is Null', a);
      return -1;
    }
    if(b === undefined || b === null){
      console.log('B is Null', b);
      return -1;
    }
    if(moment(a).isBefore(moment(b))){
      return -1;
    }
    if(moment(a).isAfter(moment(b))){
      return 1;
    }
    return 0;
  }

  headerComponent() {
    return (
      <span style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <span style={{}}>
          {/*<Search
            placeholder="input search text"
            onSearch={value => this.search(value)}
            style={{ width: 200, marginRight: 15 }}
          /> */}
        </span>
      <span style={{}}>
        <Button
          style={{ margin: 5 }}
          type="primary"
          onClick={() => this.setState({ visible: true })}
          icon="plus"
          loading={
            this.state.loading || this.props.userStore.users.fetching
          }
        >
          Nouveau
        </Button>
        <Button
            type="danger"
            onClick={this.doDelete}
            icon="delete"
            disabled={!(this.state.selection.length > 0)}
            loading={this.state.loading}
          >Supprimer</Button>
      </span>
    </span>
    )
  }
  render() {
    return (
      <div>
        <Modal
          title="Nouvel Utilisateur"
          style={{ top: 20}}
          width={900}
          visible={this.state.visible}
          onCancel={() => this.setState({ visible: false })}
          footer={null}
        >
          <UserForm submit={createUser} isCreate={true} closeModal={() =>this.setState({visible :false})}/>
        </Modal>
        <h1>Utilisateurs</h1>

{/*        {this.props.userStore.users.docs.map((doc, i) => (
           <a key={i}>{doc.data.firstname}</a>
        ))}*/}
        {this.props.userStore.users.query != undefined ?
          <span><Alert message={<span>Un ou plusieurs filtres sont actifs, réinitialiser les en <a onClick={this.reset}>cliquant ici</a> afin d'afficher toutes les données.</span>} type="info" showIcon /><br/></span>
        : null
        }


        {/*<Spin indicator={{spinning: true, indicator:{<Icon type="loading" style={{ fontSize: 24 }} spin />} }} />*/ }

        <Table
          loading={{
            spinning: this.props.userStore.users.fetching,
            indicator: <Icon type="loading" style={{ fontSize: 24 }} spin />,
          wrapperClassName: 'spinWrapper'
          }}
          title={()=> this.headerComponent()}
          bordered
          dataSource={this.props.userStore.users.docs.map((doc,i) => ({
                  key: i,
                  email: doc.data.email,
                  firstname: doc.data.firstname,
                  lastname: doc.data.lastname,
                  city: doc.data.city,
                  managedAcc: doc.data.accountManager ? true : false,
                  role: doc.data.role,
                  uid: doc.id,
                  createTime: doc.data.createTime,
                  doc: doc
                }))}
          rowSelection={this.selector}
          columns={[
            { title: "Email", dataIndex: "email", key: "email", render: this.renderLink, sorter: (a, b) => this.doStringSort(a.email, b.email)},
            { title: "Prénom", dataIndex: "firstname", key: "fistname", sorter: (a, b) => this.doStringSort(a.firstname, b.firstname)},
            { title: "Nom", dataIndex: "lastname", key: "lastname", sorter: (a, b) => this.doStringSort(a.lastname, b.lastname) },
            { title: "Date d'inscription", dataIndex: "createTime", defaultSortOrder: "ascend", key: "createTime", sorter: (a,b) => this.doDateSort(a.createTime, b.createTime), render: value => <span style={{whiteSpace: "nowrap"}}>{moment(value).format('DD-MM-YYYY HH[h]mm')}</span> },
            { title: "Ville", dataIndex: "city", key: "city", sorter: (a, b) => this.doStringSort(a.city, b.city) },
            { title: "Proche", dataIndex: "managedAcc", key: "managedAcc", sorter: (a, b) => a.managedAcc ? 1 : -1, render: value => value ? <Icon type="check-square"/> : <Icon type="close-square-o"/> },
            { title: "Rôle", dataIndex: "role", render: this.renderTag, key: "role", filters: [{text: 'Admin', value: 'admin'},{text: 'Client', value: 'patient'},{text: 'Intervenant', value: 'nurse'}], onFilter: (val, record) => {return record.role ? (record.role.indexOf(val) === 0) : false }},
          ]} />

      </div>
    );
  }
}
// {this.props.userStore.users.docs.map((doc, i) => (
//   <a key={i}>{doc.data.firstname}</a>
// ))}
const authCondition = authUser => !!authUser;

export default compose(
  withAuthorization(authCondition),
  inject("userStore"),
  withRouter,
  observer
)(Users);



// WEBPACK FOOTER //
// ./src/Users.js